import { useEffect, useState } from 'react';
import { formatNumber } from '../lib/format';

function motionAllowed(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/** Counts from 0 to `value` once. Shows the final value at once under reduced motion (and in tests). */
export function CountUp({
  value,
  format = formatNumber,
  durationMs = 600,
}: {
  value: number;
  format?: (n: number) => string;
  durationMs?: number;
}) {
  const [shown, setShown] = useState(() => (motionAllowed() ? 0 : value));

  useEffect(() => {
    if (!motionAllowed()) {
      setShown(value);
      return;
    }
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / durationMs);
      setShown(Math.round(value * (1 - (1 - t) ** 3)));
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [value, durationMs]);

  return <span className="tabular-nums">{format(shown)}</span>;
}
